import Main from '@/view/main'
import parentView from '@/components/parent-view'
import emView from '@/view/employee/relations/relationsMenu'
import orgDepartmentView from '@/view/org/department/orgDepartmentView'
import orgPositionView from '@/view/org/position/orgPositionView'
import employeeInfo from '@/view/employee/detail/employee-info'
import accountView from '@/view/setting/account/accountView'
import corpView from '@/view/setting/corp/corpView'
import attendanceMonthly from '@/view/attendance/monthly/attendanceMonthly'
import attendanceSettingView from '@/view/attendance/setting/attendanceSettingView'
import attendanceVacationView from '@/view/attendance/vacation/attendanceVacationView'
import salarySettingView from '@/view/salaryManagement/setting/salarySettingView'
import sysSetView from '@/view/sysSet/sysSetView.vue'
import approvalInterfaceView from '@/view/approval-new/interface-management/approvalInterfaceView.vue'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  auth:(false) 设为ture后 是需要进行校验的路由 token
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 * }
 */
// redirect:'/', //不加会有警告
export default [

// web端开始
  {
    path: '/fastlogin',
    name: 'fastlogin',
    meta: {
      title: '登录中间页',
      auth:true,
      hideInMenu: true
    },
    component: ()=> import('@/view/web/home/commponents/fastlogin')
  },
  {
    path: '/',
    name: 'webHome',
    meta: {
      hideInMenu: true,
      auth:true,
    },
    component: () => import('@/view/web/home/home')
  },

  {
    path: '/login',
    name: 'login',
    meta: {
      hideInMenu: true,
      auth:true,
    },
    component: () => import('@/view/web/home/login.vue')
  },
  {
    path: '/reg',
    name: 'reg',
    meta: {
      hideInMenu: true,
      auth:true,
    },
    component: () => import('@/view/web/home/reg.vue')
  },
  // web端结束


  // ************************************//
  // 管理后台
  // ************************************//


  // 工作台
  {
    path: '/workbench',
    name: 'workbench',
    redirect: '/workbench/home',
    component: Main,
    title:'我的工作台',
    children: [
      {
        path: 'home',
        name: 'workbench-home',
        meta: {
          icon: '_workbench',
          title: '我的工作台'
        },
        component: () => import('@/view/workbench/home/home.vue')
      },
      {
        path: 'notify',
        name: 'workbench-notify',
        meta: {
          icon: '_workbench',
          hideInMenu: true,
          title: '消息通知'
        },
        component: () => import('@/view/workbench/notify/notify.vue')
      },
      {
        path: ':id/notifyInfo',
        name: 'workbench-notify-info',
        meta: {
          icon: '_workbench',
          hideInMenu: true,
          title: '消息通知详情'
        },
        component: () => import('@/view/workbench/notify/notifyInfo.vue')
      }
    ]
  },

  // 员工管理
  //为了重定向  ==
  {
    path: '/employee',
    redirect: '/employee/roster/list',
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/employee/roster',
    redirect:'/employee/roster/list',
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/employee/relations',
    redirect:'/employee/relations/enrollment/home',
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/employee/contract',
    redirect:'/employee/contract/list',
    meta: {
      hideInMenu: true,
    },
  },


  /// 重定向结束

    //员工管理
  {
    path: '/employee',
    name: 'employee',
    meta:{
      icon: 'ios-people',
      title:'员工管理',
      // to:'/employee/roster/list',
      access:[1,2,29,31,32]
    },
    component: Main,
    children: [
      {
        path: 'import-roster',
        name: 'import_roster',
        meta: {
          hideInMenu: true,
          access: [2],
          homeRouter:'roster',
        },
        component: () => import('@/view/employee/import-roster/import-roster'),
      },
      {//员工详情信息
        path:'detail/:id',
        name:'employee_info',
        meta:{
          title:'员工详情',
          hideInMenu: true,
          access: [1],
          homeRouter:'roster',
        },
        redirect:'detail/:id/personal-info',
        component:employeeInfo,
        children:[
          {
            path:'personal-info',
            name:'personal_info',
            title:'员工详情-个人信息',
            meta:{
              access: [1],
              homeRouter:'roster',
            },
            component: () => import('@/view/employee/detail/personal-info'),
          },
          {
            path:'contact-detail',
            name:'contact_detail',
            title:'员工详情-联系信息',
            meta:{
              access: [1],
              homeRouter:'roster',
            },
            component: () => import('@/view/employee/detail/contact-detail'),
          },
          {
            path:'position-detail',
            name:'position_detail',
            title:'员工详情-岗位信息',
            meta:{
              access: [1],
              homeRouter:'roster',
            },
            component: () => import('@/view/employee/detail/position-detail'),
          },{
            path:'contract-detail',
            name:'contract_detail',
            title:'员工详情-合同信息',
            meta:{
              access: [1],
              homeRouter:'roster',
            },
            component: () => import('@/view/employee/detail/contract-detail'),
          },
        ],
      },
      //员工-员工花名册
      {
        path: 'roster',
        name: 'roster',
        meta: {
          access: [1],  //权限数组。
          icon: '_employee-info',
          title: '员工花名册',
        },
        component:parentView,
        redirect:'roster/list',
        children:[
          {//员工-员工花名册列表
            path: 'list',
            name: 'rosterList',
            meta: {
              access: [1],
              icon: '_employee-info',
              title: '员工花名册',
              hideInMenu: true,
              homeRouter:'roster',
              keepAlive:true,
              isBack:true,
            },
            component: () => import('@/view/employee/roster')
          },
          { //员工-员工关系-入职管理-添加员工
            path: 'add-employee',
            name: 'addEmployee',
            meta: {
              title: '添加员工',
              hideInMenu: true,
              access: [2],
              homeRouter:'roster',
            },
            component: () => import('@/view/employee/relations/enrolloment/add-employee/add-employee.vue'),
          },
          { //员工-员工关系-入职管理-添加员工
            path: 'add-newEmployee',
            name: 'addNewEmployee',
            meta: {
              title: '添加待入职',
              hideInMenu: true,
              access: [1],
              homeRouter:'roster',
            },
            component: () => import('@/view/employee/relations/enrolloment/add-employee/add-newEmployee.vue'),
          },
          {
            path: '/employee/relations/departure/:id/departure-approval',
            name: 'departure_approval',
            meta: {
              title:'离职信息填写',
              homeRouter:'relations',
              hideInMenu: true,
              access: [2],
            },
            component: () => import('@/view/employee/relations/departure/approval'),
          },
        ],
      },
      //员工-员工关系 未设置权限
      {
        path: 'relations',
        name: 'relations',
        meta: {
          icon: 'ios-settings',
          title: '员工关系',
          hideInMenu: false, //隐藏员工关系左侧链接入口
          access: [31],
        },
        component:emView,  //入职管理路由
        redirect:'relations/enrollment/home',
        children:[
          { //员工-员工关系-入职管理
            path: 'enrollment',
            name: 'enrollment',
            meta: {
              hideInMenu: true,
              title: '入职管理',
            },
            component:parentView,
            redirect:'enrollment/home',
            children:[
              {
                path: 'home',
                name: 'enrollment_home',
                meta: {
                  title:'入职管理_首页',
                  homeRouter:'relations',
                },
                component: () => import('@/view/employee/relations/enrolloment'),
              },
              {
                path: 'entry-add',
                name: 'entry-add',
                meta: {
                  title:'添加待入职',
                  homeRouter:'relations',
                  hideInMenu: true,
                },
                component: () => import('@/view/employee/relations/entry/add.vue'),
              },
              {
                path: ':id/entry-detail',
                name: 'entry-detail',
                meta: {
                  title:'待入职员工详情',
                  homeRouter:'relations',
                  hideInMenu: true,
                },
                component: () => import('@/view/employee/relations/entry/detail.vue'),
              },
              {
                path: ':id/print-form',
                name: 'print-form',
                meta: {
                  title:'打印入职登记表',
                  homeRouter:'relations',
                  hideInMenu: true,
                },
                component: () => import('@/view/employee/relations/entry/print-form.vue'),
              },
            ],
          },
          { //员工-员工关系-转正管理
            path: 'probation',
            name: 'probation',
            meta: {
              hideInMenu: true,
              title: '转正管理',
            },
            component:parentView,
            redirect:'probation/home',
            children:[
              {
                path: 'home',
                name: 'probation_home',
                meta: {
                  title:'转正管理_首页',
                  homeRouter:'relations'
                },
                component: () => import('@/view/employee/relations/probation'),

              }
            ],
          },
          { //员工-员工关系-离职管理
            path: 'departure',
            name: 'departure',
            meta: {
              hideInMenu: true,
              title: '离职管理',
            },
            component:parentView,
            redirect:'departure/home',
            children:[
              {
                path: 'home',
                name: 'departure_home',
                meta: {
                  title:'离职管理',
                  homeRouter:'relations'
                },
                component: () => import('@/view/employee/relations/departure'),
              },
              {
                path: 'approval',
                name: 'departure_approval_home',
                meta: {
                  title:'离职信息填写',
                  homeRouter:'relations'
                },
                component: () => import('@/view/employee/relations/departure/approval'),
              },
            ],
          },
          //
        ]
      },
      {//员工属性审核
        path: 'field-audit',
        name: 'field-audit',
        meta: {
          icon: 'ios-color-wand',
          title: '员工信息审核',
          access:[29],
        },
        redirect:'field-audit/list',
        component:parentView,
        children:[
          {//员工信息审核列表
            path: 'list',
            name: 'field-list',
            meta: {
              // access: ['super_admin'],  //权限数组。 admin的时候不显示
              title: '员工信息审核列表',
              hideInMenu: true,
              homeRouter: 'field-audit',
              access:[29],
              keepAlive:true,
              isBack:true,
            },
            component: () => import('@/view/employee/field-audit/list.vue')
          },
          {//员工信息审核详情
            path: ':id&:states/detail',
            name: 'field-detail',
            meta: {
              title: '员工信息审核详情',
              hideInMenu: true,
              homeRouter: 'field-audit',
              access:[29],
              // keepAlive:false,
              // isBack:false
            },
            component: () => import('@/view/employee/field-audit/detail.vue')
          },
        ],
      },
      {//合同管理
        path: 'contract',
        name: 'contract',
        meta: {
          icon: 'ios-keypad',
          title: '合同管理',
          access:[29],
        },
        redirect:'contract',
        component:parentView,
        children:[
          {//合同管理列表
            path: 'list',
            name: 'contract-list',
            meta: {
              // access: ['super_admin'],  //权限数组。 admin的时候不显示
              title: '合同管理列表',
              hideInMenu: true,
              homeRouter: 'contract',
              access:[29],
              keepAlive:true,
              isBack:true,
            },
            component: () => import('@/view/employee/contract/list.vue')
          }
        ],
      },
      // {
      //   path: 'attribute',
      //   name: 'attribute',
      //   meta: {
      //     icon: 'asterisk',
      //     title: '员工属性管理',
      //   },
      //   redirect:'attribute/list',
      //   component:parentView,
      //   children: [
      //     {
      //       path: 'list',
      //       name: 'attrib-list',
      //       meta: {
      //         title: '员工属性列表',
      //         hideInMenu: true,
      //         homeRouter: 'attribute',
      //       },
      //       component: () => import('@/view/employee/attribute/list.vue')
      //     },
      //   ],
      // },

      // {
      //   path: 'archive',
      //   name: 'archive',
      //   meta: {
      //     icon: '_error',
      //     title: '员工档案库',
      //     hideInMenu:true
      //   },
      //   component: () => import('@/view/workbench/home')
      // },
    ]
  },
  //组织管理
  {
    path: '/org',
    name: 'org',
    component: Main,
    meta:{
      icon: 'social-buffer',
      title:'组织管理',
      to:'/org/department/manage/home',
      access:[3,4,5]
    },
    redirect:'org/department/manage/home',
    children: [
      {
        path: 'department',
        name: 'department',
        meta: {
          title: '组织架构',
          icon:'_org',
          to:'/org/department/manage/home',
          access:[3]
        },
        redirect:'department/manage',
        component:orgDepartmentView,  //组织架构路由
        children:[
          {
            path: 'manage',
            name: 'manage',
            meta: {
              hideInMenu: true,
              title: '组织管理',
              access:[3]
            },
            redirect:'manage/home',
            component:parentView,
            children:[
              {
                path:'home',
                name:'manage_home',
                meta:{
                  title:'组织管理-首页',
                  homeRouter:'department',
                  access:[3],
                  keepAlive:true,
                  isBack:true,
                },
                component: () => import('@/view/org/department/manage/home'),
              },
              {
                path:':id/detail',
                name:'manage_detail',
                meta:{
                  title:'组织详情',
                  homeRouter:'department',
                  access:[3]
                },
                component: () => import('@/view/org/department/manage/detail'),
              },
              {
                path: 'import-organization',
                name: 'importOrganization',
                meta: {
                  hideInMenu: true,
                  access: [4],
                  homeRouter:'department',
                },
                component: () => import('@/view/org/department/manage/import-organization'),
              },
            ]
          },
          {
            path: 'chart',
            name: 'chart',
            meta: {
              hideInMenu: true,
              title: '组织架构图',
              access:[3]
            },
            redirect:'chart/home',
            component:parentView,
            children:[
              {
                path:'home',
                name:'chart_home',
                meta:{
                  title:'组织架构图-首页',
                  homeRouter:'department',
                  access:[3]
                },
                component: () => import('@/view/org/department/chart/home'),
              }
            ]
          }
        ]
      },
      {
        path: 'position',
        name: 'position',
        meta: {
          icon: '_post',
          title: '岗位管理',
          access:[5]
        },
        redirect:'position/home',
        component:orgPositionView,  //岗位管理路由
        children:[
          {
            path: 'import-cost',
            name: 'import_cost',
            meta: {
              hideInMenu: true,
              access: [5],
              homeRouter:'position',
            },
            component: () => import('@/view/org/import-cost/import-cost'),
          },
          {
            path: 'home',
            name: 'position_home',
            meta: {
              hideInMenu: true,
              title: '岗位管理',
              homeRouter:'position',
              access:[5]
            },
            component: () => import('@/view/org/position/home'),
          },
          {
            path:':id/detail',
            name:'post_detail',
            meta:{
              hideInMenu: true,
              title:'岗位详情',
              homeRouter:'position',
              access:[5]
            },
            component: () => import('@/view/org/position/job-detail'),
          },
          {
            path: 'position-evaluation',
            name: 'position-evaluation',
            meta: {
              hideInMenu: true,
              title: '岗位类别',
              homeRouter:'position',
              access:[5]
            },
            component: () => import('@/view/org/position/position-evaluation'),
          },
          {
            path: 'job-level',
            name: 'job-level',
            meta: {
              hideInMenu: true,
              title: '岗位职级',
              homeRouter:'position',
              access:[5]
            },
            component: () => import('@/view/org/position/job-level'),
          },
          {
            path: 'job-dictionary',
            name: 'dictionary',
            meta: {
              hideInMenu: true,
              title: '岗位词典',
              homeRouter:'position',
              access:[5]
            },
            component: () => import('@/view/org/position/job-dictionary'),
          },
          {
            path: 'cost-center',
            name: 'costCenter',
            meta: {
              hideInMenu: true,
              title: '成本中心',
              homeRouter:'position',
              access:[5]
            },
            component: () => import('@/view/org/position/cost-center'),
          },
          {
            path: 'contract-company',
            name: 'contractCompany',
            meta: {
              hideInMenu: true,
              title: '成本中心',
              homeRouter:'position',
              access:[5]
            },
            component: () => import('@/view/org/position/contract-company'),
          }
        ]
      },
    ]
  },

  //考勤
  {
    path: '/attendance',
    name: 'attendance',
    component: Main,
    meta:{
      breadHide:true,
      icon: 'leaf',
      title:'考勤',
      access:[6,7,8,10,11]
    },
    redirect:'attendance/monthly/list/home',
    children: [
      {
        //考勤管理1111111111111
        path: 'monthly',
        name: 'attendance_monthly',
        meta: {
          icon: '_attendance',
          title: '考勤管理',
          breadHide:true,
          access:[6,7]
        },
        redirect:'monthly/list/',
        component:attendanceMonthly,
        children:[
          {
            path: 'list',
            name: 'attendance_monthly_list',
            meta: {
              hideInMenu: true,
              title: '出勤记录明细',
              homeRouter:'attendance_monthly',
              access:[6]
            },
            redirect:'list/',
            component:parentView,
            children:[
              {
                path: '/',
                name: 'attendance_monthly_list_home',
                meta: {
                  hideInMenu: true,
                  title: '出勤记录明细',
                  homeRouter:'attendance_monthly',
                  access:[6],
                },
                component: () => import('@/view/attendance/monthly/list/home.vue'),
              },
              {
                path: 'import-daysOffRecord',
                name: 'attendance_monthly_daysOffRecord_import',
                meta: {
                  hideInMenu: true,
                  homeRouter:'attendance_monthly',
                  access:[7]
                },
                component: () => import('@/view/attendance/monthly/daysOffRecord/import-daysOffRecord.vue'),
              },
              {
                //导入考勤数据
                path: 'import-attendance',
                name: 'import_attendance',
                meta: {
                  hideInMenu: true,
                  homeRouter:'attendance_monthly',
                  access:[7]
                },
                component: () => import('@/view/attendance/monthly/import-attendance/import-attendance'),
              },
            ]
          },



          {
            path: 'record',
            name: 'attendance_monthly_record',
            meta: {
              hideInMenu: true,
              // title: '历史考勤',
              homeRouter:'attendance_monthly',
              access:[6]
            },
            component: () => import('@/view/attendance/monthly/record/home.vue'),
          },
          {
            path: 'daysOffRecord',
            name: 'attendance_monthly_daysOffRecord',
            meta: {
              hideInMenu: true,
              // title: '调休记录',
              homeRouter:'attendance_monthly',
              access:[6]
            },
            component: () => import('@/view/attendance/monthly/daysOffRecord/home.vue'),

          },

          {
            path: 'overTimeRecord',
            name: 'attendance_monthly_overTimeRecord',
            meta: {
              hideInMenu: true,
              // title: '加班记录',
              homeRouter:'attendance_monthly',
              access:[6]
            },
            component: () => import('@/view/attendance/monthly/overTimeRecord/home.vue'),
          },

        ]
      },
      {
        //考勤设置222222222222222
        path: 'setting',
        name: 'attendance_setting',
        meta: {
          icon: '_set',
          title: '考勤设置',
          to:'/attendance/setting/group',
          access:[8]
        },
        redirect:'setting/group',
        component:attendanceSettingView,
        children:[
          {
            path: 'group',
            // name: 'attendance_setting_group',
            meta: {
              hideInMenu: true,
              title: '考勤组管理',
              homeRouter:'attendance_setting',
              to:'/attendance/setting/group',
              access:[8]
            },
            component: parentView,
            children:[
              { //员工-员工关系-入职管理-添加员工
                path: '/',
                name: 'attendance_setting_group_home',
                meta: {
                  title: '考勤组管理',
                  hideInMenu: true,
                  homeRouter:'attendance_setting',
                  access:[8]
                },
                component: () => import('@/view/attendance/setting/group/group'),
              },
              { //员工-员工关系-入职管理-添加员工
                path: 'add',
                name: 'addGroup',
                meta: {
                  title: '添加考勤组',
                  homeRouter:'attendance_setting',
                  access:[8]
                },
                component: () => import('@/view/attendance/setting/group/add'),
              },
            ]
          },

          {
            path: 'rule',
            // name: 'attendance_setting_rule',
            meta: {
              hideInMenu: true,
              title: '考勤规则',
              homeRouter:'attendance_setting',
              to:'/attendance/setting/rule',
              access:[8]
            },
            component: parentView,
            children:[
              {
                path: '/',
                name: 'attendance_setting_rule_home',
                meta: {
                  title: '考勤规则',
                  homeRouter:'attendance_setting',
                  access:[8]
                },
                component: () => import('@/view/attendance/setting/rule/rule'),
              },
              {
                path: 'add',
                name: 'addRule',
                meta: {
                  title: '添加考勤方案',
                  homeRouter:'attendance_setting',
                  access:[8]
                },
                component: () => import('@/view/attendance/setting/rule/rule-add'),
              },
            ]
          },
          {
            path: 'shift',
            // name: 'attendance_setting_shift',
            meta: {
              hideInMenu: true,
              title: '考勤班次',
              homeRouter:'attendance_setting',
              to:'/attendance/setting/shift',
              access:[8]
            },
            component: parentView,
            children:[
              {
                path: '/',
                name: 'attendance_setting_shift_home',
                meta: {
                  title: '考勤班次',
                  homeRouter:'attendance_setting',
                  access:[8]
                },
                component: () => import('@/view/attendance/setting/shift/shift'),
              },
              {
                path: 'add',
                name: 'addShift',
                meta: {
                  title: '新增班次',
                  homeRouter:'attendance_setting',
                  access:[8]
                },
                component: () => import('@/view/attendance/setting/shift/shift-add'),
              },
            ]
          },
          {
            path: 'individuation',
            name: 'attendance_setting_individuation',
            meta: {
              hideInMenu: true,
              // title: '企业(假期)设置',
              homeRouter:'attendance_setting',
              access:[8]
            },
            component: () => import('@/view/attendance/setting/individuation/individuation'),
          },
        ]
      },
      {
        //假期管理3333333333333
        path: 'vacation',
        name: 'attendance_vacation',
        meta: {
          icon: '_vacation',
          title: '假期管理',
          access:[10,11]
        },
        redirect:'vacation/annual/',
        component:attendanceVacationView,
        children:[
          {
            path: 'annual',
            name: 'attendance_vacation_annual',
            meta: {
              hideInMenu: true,
              // title: '年休假管理',
              homeRouter:'attendance_vacation',
              access:[10]
            },
            redirect:'/attendance/vacation/annual/',
            component:parentView,
            children:[
              {
                path: '/',
                name: 'attendance_vacation_annual_home',
                meta: {
                  hideInMenu: true,
                  // title: '年休假管理',
                  homeRouter:'attendance_vacation',
                  access:[10]
                },
                component: () => import('@/view/attendance/vacation/annual/annual'),
              },
              {
                path: 'import-annual',
                name: 'attendance_vacation_annual_import',
                meta: {
                  hideInMenu: true,
                  // title: '导入年休',
                  homeRouter:'attendance_vacation',
                  access:[11]
                },
                component: () => import('@/view/attendance/vacation/annual/importAnnual'),
              },
            ]
          },

          // {
          //   path: 'overtime',
          //   name: 'attendance_vacation_overtime',
          //   meta: {
          //     hideInMenu: true,
          //     // title: '加班记录',
          //     homeRouter:'attendance_vacation',
          //     access:[6]
          //   },
          //   component: () => import('@/view/attendance/vacation/overtime/overtime'),
          // },
          // {
          //   path: 'tune',
          //   name: 'attendance_vacation_tune',
          //   meta: {
          //     hideInMenu: true,
          //     // title: '调休统计',
          //     homeRouter:'attendance_vacation',
          //     access:[6]
          //   },
          //   component: () => import('@/view/attendance/vacation/tune/tune'),
          // },
        ]
      },
    ]
  },
  //薪酬
  {
    path:'/salaryManagement',
    name:'salaryManagement',
    meta:{
      breadHide:true,
      icon: 'social-yen',
      title:'薪酬',
      access:[12,13,14,15,33,34]
    },
    component: Main,
    redirect:'salaryManagement/monthly/list',
    children:[
      {
        //当月工资
        path: 'monthly',
        name: 'salaryManagement_monthly',
        meta: {
          icon: 'calendar',
          title: '当月工资',
          breadHide:true,
          access:[12]
        },
        redirect:'monthly/list',
        component:parentView,
        children:[
          {
            path: 'list',
            name: 'salaryManagement_monthly_list',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_monthly',
              access:[12],
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/salaryManagement/monthly/list'),
          },
          {
            path: 'import',
            name: 'salaryManagement_monthly_import',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_monthly',
              access:[13]
            },
            component: () => import('@/view/salaryManagement/monthly/import'),
          },
          {
            path: ':id/single-import',
            name: 'salaryManagement_monthly_single_import',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_monthly',
              access:[13]
            },
            component: () => import('@/view/salaryManagement/monthly/single-import'),
          },
          {
            path: ':id/salary-details',
            name: 'salaryManagement_monthly_details',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_monthly',
              access:[12]
            },
            component: () => import('@/view/salaryManagement/monthly/salary-details'),
          },
          {
            path: ':id/add',
            name: 'salaryManagement_monthly_add',
            meta: {
              title: '发起调薪',
              hideInMenu: true,
              homeRouter:'salaryManagement_monthly',
              access:[13] //原为12，改为13薪酬数据操作
            },
            component: () => import('@/view/salaryManagement/monthly/add'),
          }
        ]
      },
      {
        //历史工资
        path: 'history',
        name: 'salaryManagement_history',
        meta: {
          icon: 'ios-bookmarks',
          title: '历史工资',
          breadHide:true,
          access:[12]
        },
        redirect:'history/list',
        component:parentView,
        children:[
          {
            path: 'list',
            name: 'salaryManagement_history_list',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_history',
              access:[12],

            },
            component: () => import('@/view/salaryManagement/history/list'),
          },
          {
            path: ':id/:yearMonth/history-salary-details',
            name: 'salaryManagement_history_monthly_details',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_history',
              access:[12]
            },
            component: () => import('@/view/salaryManagement/history/history-salary-details'),
          },
          {
            path: 'monthly/:yearMonth',
            name: 'salaryManagement_history_monthly',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_history',
              access:[12],
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/salaryManagement/history/monthly'),
          },
          {
            path: 'monthlyImported/:yearMonth',
            name: 'salaryManagement_history_monthlyImported',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_history',
              access:[13]
            },
            component: () => import('@/view/salaryManagement/history/monthlyImported'),
          },
          {
            // path: 'importSalaryHistory/:yearMonth',
            path: 'importSalaryHistory',
            name: 'import_history_salary',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_history',
              access:[13]
            },
            component: () => import('@/view/salaryManagement/history/importSalaryHistory'),
          },
          {
            path: ':id/:yearMonth/taxCorrection',
            name: 'salaryManagement_history_monthly_taxCorrection',
            meta: {
              title: '个税纠错',
              hideInMenu: true,
              homeRouter: 'salaryManagement_history',
              access: [13]
            },
            component: () => import('@/view/salaryManagement/history/taxCorrection'),
          }
        ]
      },
      {
        //薪酬设置
        path: 'setting',
        name: 'salaryManagement_setting',
        meta: {
          icon: 'settings',
          title: '薪酬设置',
          breadHide:true,
          access:[14]
        },
        redirect:'setting/structure',
        component:salarySettingView,
        children:[
          {
            path: 'structure',
            name: 'salaryManagement_setting_structure',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_setting',
              access:[14]
            },
            component: () => import('@/view/salaryManagement/setting/structure/structure'),
          },
          {
            path: 'rule',
            // name: 'salaryManagement_setting_rule',
            meta: {
              title: '计薪方案',
              hideInMenu: true,
              homeRouter:'salaryManagement_setting',
              to:'/salaryManagement/setting/rule',
              access:[14]
            },
            component: parentView,
            children:[
              {
                path: '/',
                name: 'salaryManagement_setting_rule_home',
                meta: {
                  title: '计薪方案',
                  homeRouter:'salaryManagement_setting',
                  access:[14]
                },
                component: () => import('@/view/salaryManagement/setting/rule/rule'),
              },
              {
                path: 'add',
                name: 'addSalaryPayable',
                meta: {
                  title: '添加计薪方案',
                  homeRouter:'salaryManagement_setting',
                  access:[14]
                },
                component: () => import('@/view/salaryManagement/setting/rule/rule-add'),
              },
            ]
          },
          {
            path: 'tax',
            // name: 'salaryManagement_setting_tax',
            meta: {
              hideInMenu: true,
              title: '计税方案',
              homeRouter:'salaryManagement_setting',
              to:'/salaryManagement/setting/tax',
              access:[14]
            },
            component: parentView,
            children:[
              {
                path: '/',
                name: 'salaryManagement_setting_tax_home',
                meta: {
                  title: '计税方案',
                  homeRouter:'salaryManagement_setting',
                  access:[14]
                },
                component: () => import('@/view/salaryManagement/setting/tax/tax'),
              },
              {
                path: ':id/edit',
                name: 'taxEdit',
                meta: {
                  title: '修改计税方案',
                  homeRouter:'salaryManagement_setting',
                  access:[14]
                },
                component: () => import('@/view/salaryManagement/setting/tax/tax-edit'),
              },
            ]
          },
          {
            path: 'allowance',
            // name: 'salaryManagement_setting_allowance',
            meta: {
              title: '津补贴方案',
              hideInMenu: true,
              homeRouter:'salaryManagement_setting',
              to:'/salaryManagement/setting/allowance',
              access:[14]
            },
            component: parentView,
            children:[
              {
                path: '/',
                name: 'salaryManagement_setting_allowance_home',
                meta: {
                  title: '津补贴方案',
                  homeRouter:'salaryManagement_setting',
                  access:[14]
                },
                component: () => import('@/view/salaryManagement/setting/allowance/allowance'),
              },
              {
                path: 'add',
                name: 'allowanceAdd',
                meta: {
                  title: '修改津补贴方案',
                  homeRouter:'salaryManagement_setting',
                  access:[14]
                },
                component: () => import('@/view/salaryManagement/setting/allowance/allowance-add'),
              },
            ]
          },
          {
            path: 'individuation',
            name: 'salaryManagement_setting_individuation',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_setting',
              access:[14]
            },
            component: () => import('@/view/salaryManagement/setting/individuation/individuation'),
          },
          {
            path: 'payrollReport',
            name: 'salaryManagement_setting_payroll',
            meta: {
              title: '企业工资标准报表',
              hideInMenu: true,
              homeRouter:'salaryManagement_setting',
              access:[14]
            },
            component: () => import('@/view/salaryManagement/setting/payrollReport/payrollReport'),
          },
        ]
      },
      {
        //调薪记录
        path: 'adjust',
        name: 'salaryManagement_adjust',
        meta: {
          icon: 'ios-paper',
          title: '调薪记录',
          breadHide:true,
          access:[12]
        },
        redirect:'adjust/record',
        component:parentView,
        children:[
          {
            path: 'record',
            name: 'salaryManagement_adjust_record',
            meta: {
              title: '调薪列表',
              hideInMenu: true,
              homeRouter:'salaryManagement_adjust',
              access:[12],
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/salaryManagement/adjust/record'),
          },
          {
            path: ':id/detail',
            name: 'salaryManagement_adjust_detail',
            meta: {
              title: '调薪详情',
              hideInMenu: true,
              homeRouter:'salaryManagement_adjust',
              access:[12]
            },
            component: () => import('@/view/salaryManagement/adjust/detail'),
          },
          {
            path: ':id/add',
            name: 'salaryManagement_adjust_add',
            meta: {
              title: '添加调薪',
              hideInMenu: true,
              homeRouter:'salaryManagement_adjust',
              access:[15]
            },
            component: () => import('@/view/salaryManagement/adjust/add'),
          },
        ]
      },
      {
        //年终奖计算
        path: 'bonus',
        name: 'salaryManagement_bonus',
        meta: {
          icon: 'social-usd',
          title: '年终奖计算',
          breadHide:true,
          access:[12]
        },
        redirect:'bonus/home',
        component:parentView,
        children:[
          {
            path: 'home',
            name: 'salaryManagement_bonus_home',
            meta: {
              title: '年终奖计算',
              hideInMenu: true,
              homeRouter:'salaryManagement_bonus',
              access:[12]
            },
            component: () => import('@/view/salaryManagement/bonus/home'),
          },
          {
            path: ':id/detail-list',
            name: 'salaryManagement_bonus_detail-list',
            meta: {
              title: '年终奖详情列表',
              hideInMenu: true,
              homeRouter:'salaryManagement_bonus',
              access:[12]
            },
            component: () => import('@/view/salaryManagement/bonus/detail-list'),
          },
          {
            path: 'import-bonus',
            name: 'salaryManagement_bonus_import-bonus',
            meta: {
              title: '导入年终奖数据',
              hideInMenu: true,
              homeRouter:'salaryManagement_bonus',
              access:[13]
            },
            component: () => import('@/view/salaryManagement/bonus/import-bonus'),
          },
        ]
      },
      {
        //历史工资
        path: 'paystub',
        name: 'salaryManagement_paystub',
        meta: {
          icon: 'android-calendar',
          title: '独立工资条',
          breadHide:true,
          access:[33]
        },
        redirect:'paystub/list',
        component:parentView,
        children:[
          {
            path: 'list',
            name: 'salaryManagement_paystub_list',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_paystub',
              access:[33],

            },
            component: () => import('@/view/salaryManagement/paystub/list'),
          },
          {
            path: 'import',
            name: 'salaryManagement_paystub_import',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_paystub',
              access:[33]
            },
            component: () => import('@/view/salaryManagement/paystub/import'),
          },
          {
            path: ':tagid&:sendPays&:ym/paystub-details',
            name: 'salaryManagement_paystub_details',
            meta: {
              hideInMenu: true,
              homeRouter:'salaryManagement_paystub',
              access:[33]
            },
            component: () => import('@/view/salaryManagement/paystub/paystub-details'),
          }
        ]
      }
    ]
  },

  //社保
  {
    path: '/ins',
    name: 'ins',
    meta: {
      icon: 'ios-medical',
      title: '社保管理',
      access:[18,19,20,21,22]
    },
    component: Main,
    children: [
      {
        path: 'ins-manage',
        name: 'ins-manage',
        meta: {
          icon: 'ios-book',
          title: '参保管理',
          access:[18]
        },
        component: parentView,
        redirect:'/ins/ins-manage/',
        children:[
          {
            path: '/',
            name: 'ins-list',
            meta: {
              icon: 'ios-book',
              title: '参保管理',
              access:[18],
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/ins/ins-list.vue')
          },
          {
            path: 'ins-list-2',
            name: 'ins-list-2',
            meta: {
              icon: 'ios-book',
              title: '参保管理-正常缴纳',
              hideInMenu: true,
              access:[18],
              homeRouter:'ins-list',
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/ins/inslist/ins-list-2.vue')
          },
          {
            path: 'ins-list-3',
            name: 'ins-list-3',
            meta: {
              icon: 'ios-book',
              title: '参保管理-未缴纳',
              hideInMenu: true,
              access:[18],
              homeRouter:'ins-list',
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/ins/inslist/ins-list-3.vue')
          },
          {
            path: 'ins-list-4',
            name: 'ins-list-4',
            meta: {
              icon: 'ios-book',
              title: '参保管理-新增',
              hideInMenu: true,
              access:[18],
              homeRouter:'ins-list',
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/ins/inslist/ins-list-4.vue')
          },
          {
            path: 'ins-list-5',
            name: 'ins-list-5',
            meta: {
              icon: 'ios-book',
              title: '参保管理-补缴',
              hideInMenu: true,
              access:[18],
              homeRouter:'ins-list',
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/ins/inslist/ins-list-5.vue')
          },
          {
            path: 'ins-list-6',
            name: 'ins-list-6',
            meta: {
              icon: 'ios-book',
              title: '参保管理-中断',
              hideInMenu: true,
              access:[18],
              homeRouter:'ins-list',
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/ins/inslist/ins-list-6.vue')
          },
          {
            path: 'ins-list-7',
            name: 'ins-list-7',
            meta: {
              icon: 'ios-book',
              title: '参保管理-离职',
              hideInMenu: true,
              access:[18],
              homeRouter:'ins-list',
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/ins/inslist/ins-list-7.vue')
          },
          {
            path: ':id/ins-add',
            name: 'ins-add',
            meta: {
              icon: 'document-text',
              title: '上社保',
              hideInMenu: true,
              access:[19],
              homeRouter:'ins-list'
            },
            component: () => import('@/view/ins/ins-add.vue')
          },
          {
            path: ':id&:planId/ins-edit',
            name: 'ins-edit',
            meta: {
              icon: 'document-text',
              title: '按参保方案编辑',
              hideInMenu: true,
              access:[19],
              homeRouter:'ins-list'
            },
            component: () => import('@/view/ins/ins-edit.vue')
          },
          {
            path: ':id/ins-edit2',
            name: 'ins-edit2',
            meta: {
              icon: 'document-text',
              title: '按参保金额编辑',
              hideInMenu: true,
              access:[19],
              homeRouter:'ins-list'
            },
            component: () => import('@/view/ins/ins-edit2.vue')
          },
          {
            // path: ':id&:planId/ins-detail',
            path: ':id/ins-detail',
            name: 'ins-detail',
            meta: {
              icon: 'document-text',
              title: '员工社保详情',
              hideInMenu: true,
              access:[18],
              homeRouter:'ins-list'
            },
            component: () => import('@/view/ins/ins-detail.vue')
          },
          {
            path: 'import-ins',
            name: 'import-ins',
            meta: {
              icon: 'document-text',
              title: '导入员工社保',
              hideInMenu: true,
              access:[19],
              homeRouter:'ins-list'
            },
            component: () => import('@/view/ins/import-ins.vue')
          },

        ]
      },
      {
        path: 'plan',
        name: 'plan',
        meta: {
          icon: 'ios-gear',
          title: '参保方案',
          access:[20,21]
        },
        component:parentView,
        redirect:'/ins/plan/',
        children:[
          {
            path: '/',
            name: 'plan-list',
            meta: {
              icon: 'ios-gear',
              title: '参保方案',
              access:[20],
            },
            component: () => import('@/view/ins/plan-list.vue'),
          },
          {
            path: 'plan-add',
            name: 'plan-add',
            meta: {
              icon: 'ios-gear',
              title: '添加参保方案',
              hideInMenu: true,
              access:[21],
              homeRouter:'plan-list',
            },
            component: () => import('@/view/ins/plan-add.vue'),
          },
          {
            path: ':id/plan-detail',
            name: 'plan-detail',
            meta: {
              icon: 'ios-gear',
              title: '参保方案明细',
              hideInMenu: true,
              access:[20],
              homeRouter:'plan-list',
            },
            component: () => import('@/view/ins/plan-detail.vue')
          },
          {
            path: ':id/plan-edit',
            name: 'plan-edit',
            meta: {
              icon: 'ios-gear',
              title: '编辑参保方案',
              hideInMenu: true,
              access:[21],
              homeRouter:'plan-list',
            },
            component: () => import('@/view/ins/plan-edit.vue')
          },
        ]
      },

      {
        path: 'bill',
        name: 'bill',
        meta: {
          icon: 'ios-grid-view',
          title: '账单列表',
          access:[18]
        },
        component:parentView,
        redirect:'/ins/bill/',
        children:[
          {
            path: '/',
            name: 'bill-list',
            meta: {
              icon: 'ios-grid-view',
              title: '账单列表',
              access:[18],
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/ins/bill-list.vue'),

          },
          {
            path: 'bill-cost/:y&:m',
            name: 'bill-cost',
            meta: {
              icon: 'ios-grid-view',
              title: '账单明细列表',
              hideInMenu: true,
              access:[18],
              homeRouter:'bill-list'
            },
            component: () => import('@/view/ins/bill-cost.vue')
          },
          {
            path: 'import-cost',
            name: 'import-cost',
            meta: {
              icon: 'ios-grid-view',
              title: '导入保险费用',
              hideInMenu: true,
              access:[19],
              homeRouter:'bill-list'
            },
            component: () => import('@/view/ins/import-cost.vue')
          },
        ]
      },

    ]
  },
  //审批
  {
    path: '/approval',
    name: 'approval',
    meta: {
      icon: 'ios-color-filter',
      title: '审批',
      access:[22,23,24,25]
    },
    component: Main,
    redirect:'/approval/approval-history/',
    children: [
      {
        path: 'approval-history',
        name: 'approval-history',
        meta: {
          icon: 'ios-paper',
          title: '审批记录',
          access:[22]
        },
        component: parentView,
        redirect:'/approval/approval-history/',
        children:[
          {
            path: '/',
            name: 'approval-history-home',
            meta: {
              icon: 'ios-paper',
              title: '审批记录',
              access:[22],
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/approval/approval-history.vue')
          },
          {
            path: ':id/approval-detail',
            name: 'approval-detail',
            meta: {
              icon: 'ios-cog',
              title: '审批详情',
              hideInMenu: true,
              access:[22],
              homeRouter:'approval-history'
            },
            component: () => import('@/view/approval/approval-detail.vue')
          },
        ]
      },

      {
        path: 'approval-setting',
        name: 'approval-setting',
        meta: {
          icon: 'ios-cog',
          title: '审批设置',
          access:[25]
        },
        component:parentView,
        redirect:'/approval/approval-setting/',
        children:[
          {
            path: ':idx/',
            name: 'approval-list',
            meta: {
              icon: 'ios-cog',
              title: '审批设置',
              access:[25]
            },
            component: () => import('@/view/approval/approval-list.vue'),
          },
          {
            path: ':id/approval-flowtemp',
            name: 'approval-flowtemp',
            meta: {
              icon: 'ios-cog',
              title: '审批表单',
              hideInMenu: true,
              access:[25],
              homeRouter:'approval-list'
            },
            component: () => import('@/view/approval/approval-flowtemp.vue')
          },
          {
            path: ':id/approval-flowitem',
            name: 'approval-flowitem',
            meta: {
              icon: 'ios-cog',
              title: '审批流',
              hideInMenu: true,
              access:[25],
              homeRouter:'approval-list'
            },
            component: () => import('@/view/approval/approval-flowitem.vue')
          },
          {
            path: ':id/approval-flow-tree',
            name: 'approval-flow-tree',
            meta: {
              icon: 'ios-cog',
              title: '审批流',
              hideInMenu: true,
              access:[25],
              homeRouter:'approval-list'
            },
            component: () => import('@/view/approval/approval-flow-tree/approval-flow-tree.vue')
          },
        ]
      },
    ]
  },
  // 新版审批
  {
    path: '/approval-new',
    name: 'approval-new',
    meta: {
      icon: 'android-contact',
      title: '人事异动',
      access:[22,23,24,25]
    },
    component: Main,
    redirect:'',
    children: [
      {
        path: 'approval-history',
        name: 'approval-new-history',
        meta: {
          icon: 'ios-paper',
          title: '人事异动记录',
          access:[22]
        },
        component: parentView,
        redirect:'/approval-new/approval-history/',
        children:[
          {
            path: '/',
            name: 'approval-new-history-home',
            meta: {
              icon: 'ios-paper',
              title: '人事异动记录',
              access:[22],
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/approval-new/approval-history.vue')
          },
          {
            path: ':id/:idx/approval-detail',
            name: 'approval-new-detail',
            meta: {
              icon: 'ios-cog',
              title: '审批详情',
              hideInMenu: true,
              access:[22],
              homeRouter:'approval-new-history-home'
            },
            component: () => import('@/view/approval-new/approval-detail.vue')
          },
        ]
      },
  
      {
        path: 'approval-setting',
        name: 'approval-new-setting',
        meta: {
          icon: 'ios-cog',
          title: '人事异动设置',
          access:[25]
        },
        component:parentView,
        redirect:'/',
        children:[
          {
            path: ':idx/',
            name: 'approval-new-list',
            meta: {
              icon: 'ios-cog',
              title: '人事异动设置',
              access:[25]
            },
            component: () => import('@/view/approval-new/approval-list.vue'),
          },
          {
            path: ':level/:id/approval-flowtemp',
            name: 'approval-new-flowtemp',
            meta: {
              icon: 'ios-cog',
              title: '审批表单',
              hideInMenu: true,
              access:[25],
              homeRouter:'approval-new-list'
            },
            component: () => import('@/view/approval-new/approval-flowtemp.vue')
          },
          {
            path: ':level/:flowName/:id/:idx/approval-flow-tree',
            name: 'approval-new-flow-tree',
            meta: {
              icon: 'ios-cog',
              title: '审批流',
              hideInMenu: true,
              access:[25],
              homeRouter:'approval-new-list'
            },
            component: () => import('@/view/approval-new/approval-flow-tree/approval-flow-tree.vue')
          },
        ]
      },
      {
        //接口管理
        path: 'interface-management',
        name: 'interface-management',
        meta: {
          icon: 'settings',
          title: '接口管理',
          breadHide:true,
          access:[25]
        },
        redirect:'interface-management/data-interface',
        component:approvalInterfaceView,
        children:[
          {
            path: 'data-interface',
            name: 'data-interface',
            meta: {
              hideInMenu: true,
              title: '数据接口',
              homeRouter:'interface-management',
              access:[25]
            },
            component: () => import('@/view/approval-new/interface-management/data.vue'),
          },
          {
            path: 'list-interface',
            name: 'list-interface',
            meta: {
              hideInMenu: true,
              title: '列表接口',
              homeRouter:'interface-management',
              access:[25]
            },
            component: () => import('@/view/approval-new/interface-management/list.vue'),
          },
  
        ]
      },
  
  
    ]
  },
  //企业设置
  {
    path: '/setting',
    name: 'setting',
    meta: {
      icon: 'ios-settings',
      title: '设置',
      hideInMenu:true,
      access:[26]
    },
    component: Main,
    children: [
      {
        path: 'corp',
        name: 'corp',
        meta: {
          icon: 'ios-settings',
          title: '企业设置',
          access:[26]
        },
        redirect:'corp/info',
        component:corpView,  //企业设置路由
        children:[
          {
            path: 'info',
            name: 'info',
            meta: {
              hideInMenu: true,
              icon: 'ios-settings',
              title: '企业信息',
              homeRouter:'corp',
              access:[26]
            },
            component: () => import('@/view/setting/corp/info.vue'),
          },
          {
            path: 'upload-license',
            name: 'upload-license',
            meta: {
              hideInMenu: true,
              icon: 'ios-settings',
              title: '企业认证',
              homeRouter:'corp',
              access:[26]
            },
            component: () => import('@/view/setting/corp/upload-license.vue'),
          },
          {
            path: 'invite-empl',
            name: 'invite-empl',
            meta: {
              hideInMenu: true,
              icon: 'ios-settings',
              title: '邀请员工',
              homeRouter:'corp',
              access:[26]
            },
            component: () => import('@/view/setting/corp/invite-empl.vue'),
          },
        ]
      },
      {
        path: 'account',
        name: 'account',
        meta: {
          icon: 'ios-settings',
          title: '个人设置'
        },
        component:accountView,  //个人设置路由
        redirect: '/setting/account/account-personal',
        children:[
          {
            path: 'account-personal',
            name: 'account-personal',
            meta: {
              hideInMenu: true,
              icon: 'ios-settings',
              title: '个人信息',
              homeRouter:'account'
            },
            component: () => import('@/view/setting/account/account.vue'),
          },
          {
            path: 'modify-password',
            name: 'modify-password',
            meta: {
              hideInMenu: true,
              icon: 'ios-settings',
              title: '修改密码',
              homeRouter:'account'
            },
            component: () => import('@/view/setting/account/modify-password.vue'),
          },
          {
            path: 'modify-mobile',
            name: 'modify-mobile',
            meta: {
              hideInMenu: true,
              icon: 'ios-settings',
              title: '修改手机号',
              homeRouter:'account'
            },
            component: () => import('@/view/setting/account/modify-mobile.vue'),
          },
        ]
      },
    ]
  },
  //权限设置
  {
    path: '/sysSet',
    name: 'sysSet',
    meta: {
      icon: 'ios-gear',
      title: '权限设置',
      // hideInMenu:true,
      access:[27,28]
    },
    component: Main,
    children: [
      {
        path: 'manager',
        name: 'manager',
        meta: {
          icon: 'person',
          title: '管理员设置',
          access:[27]
        },
        redirect:'manager/list',
        component:sysSetView,  //企业设置路由
        children:[
          {
            path: 'list',
            name: 'manager-list',
            meta: {
              hideInMenu: true,
              icon: 'ios-settings',
              title: '管理员列表',
              homeRouter:'manager',
              access:[27],
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/sysSet/manager/list.vue'),
          },
          // {
          //   path: 'add',
          //   name: 'manager-add',
          //   meta: {
          //     hideInMenu: true,
          //     icon: 'ios-settings',
          //     title: '添加管理员',
          //     homeRouter:'sysSet'
          //   },
          //   component: () => import('@/view/sysSet/manager/add.vue'),
          // },
        ]
      },
      {
        path: 'permission',
        name: 'permission',
        meta: {
          icon: 'ios-flower',
          title: '角色设置',
          access:[28]
        },
        component:sysSetView,  //角色设置路由
        redirect: 'permission/list',
        children:[
          {
            path: 'list',
            name: 'permission-list',
            meta: {
              hideInMenu: true,
              icon: 'ios-settings',
              title: '角色列表',
              homeRouter:'permission',
              access:[28],
              keepAlive:true,
              isBack:true
            },
            component: () => import('@/view/sysSet/permission/list.vue'),
          },
          // {
          //   path: 'add',
          //   name: 'permission-add',
          //   meta: {
          //     hideInMenu: true,
          //     icon: 'ios-settings',
          //     title: '新增角色',
          //     homeRouter:'permission'
          //   },
          //   component: () => import('@/view/sysSet/permission/add.vue'),
          // },
        ]
      },
      {
        path: 'permission/add',
        name: 'permission-add',
        meta: {
          hideInMenu: true,
          title: '新增角色',
          homeRouter:'permission',
          access:[28]
        },
        component: () => import('@/view/sysSet/permission/add.vue'),
      },
      {
        path: 'permission/:id/detail',
        name: 'permission-detail',
        meta: {
          hideInMenu: true,
          title: '角色详情',
          homeRouter:'permission',
          access:[28]
        },
        component: () => import('@/view/sysSet/permission/detail.vue'),
      },
      {
        path: 'manager/add',
        name: 'manager-add',
        meta: {
          hideInMenu: true,
          title: '新增管理员',
          homeRouter:'manager',
          access:[27]
        },
        component: () => import('@/view/sysSet/manager/add.vue'),
      },
      {
        path: 'manager/:id/detail',
        name: 'manager-detail',
        meta: {
          hideInMenu: true,
          title: '管理员详情',
          homeRouter:'manager',
          access:[27]
        },
        component: () => import('@/view/sysSet/manager/detail.vue'),
      },
    ]
  },

//   邀请企业列表
  {
    path: '/hope',
    name: 'hope',
    meta: {
      icon: 'ios-gear',
      title: '帮助',
      // hideInMenu:true,
    },
    component: Main,
    redirect:'',
    children: [
        {
          path: 'list',
          name: 'business-list',
          meta: {
            icon: 'person',
            title: '邀请列表'
          },
          component: () => import('@/view/hope/business/list.vue')
        }
      ]
    
  },
  //其它页面
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  },

]






// WEBPACK FOOTER //
// ./src/router/routers.js